import { render, staticRenderFns } from "./WaybillForm.vue?vue&type=template&id=8a7a36f4&scoped=true&"
import script from "./WaybillForm.vue?vue&type=script&lang=js&"
export * from "./WaybillForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7a36f4",
  null
  
)

export default component.exports